module.exports = __webpack_public_path__ + "img/chrome.f270cb9a.png";